module.exports = __webpack_public_path__ + "img/mobile_phones.0edb6df4.svg";